import {node_observable_component} from "common/util/ComponentDecorator";

@node_observable_component

export default class Toggler {
	static classname = 'toggler';

	constructor($toggler) {
		this.$toggler = $toggler;

		this.bindEvents();
	}

	bindEvents() {
		this.$toggler.find('.toggler__btn1').on('click', () => {
			this.$toggler.removeClass('toggler_st1 toggler_st2 toggler_st3').addClass('toggler_st1');
			this.changeValue(0);
		});
		this.$toggler.find('.toggler__btn2').on('click', () => {
			this.$toggler.removeClass('toggler_st1 toggler_st2 toggler_st3').addClass('toggler_st2');
			this.changeValue(1);
		});
		this.$toggler.find('.toggler__btn3').on('click', () => {
			this.$toggler.removeClass('toggler_st1 toggler_st2 toggler_st3').addClass('toggler_st3');
			this.changeValue(2);
		});
	}

	changeValue(args) {
		const $togglerD = $('.toggler--d');
		const $togglerM = $('.toggler--m');

		if($togglerD.length > 0) {
			const $toggler = $togglerD;
			const viewTypes = $toggler.data('types').split(',');
			const viewType = viewTypes[args];
			Cookies.set('product_view', viewType);
			this.replaceProducts();
		} else if ($togglerM.length > 0) {
			const $toggler = $togglerM;
			const viewTypes = $toggler.data('types').split(',');
			const viewType = viewTypes[args];
			Cookies.set('product_m-view', viewType);
			this.replaceProducts();
		}
	}

	replaceProducts() {
		$.get(window.location, function(html) {
			if ($('sorting-options').data('can-json')) {
				try {
					const response = JSON.parse(html);

					if (response.data) {
						html = response.data;
					}
				} catch(e) { }
			}

			$(document).trigger('replace_products', html);
		})
	}
}
